import { checkboxFilter } from './checkbox-filter';

export const HideDisabledFilter = checkboxFilter('hideDisabled', 'Hide Disabled');
